import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    infoData: {},
    formData: [],
    initialData: {},
    selectedList: {},
    status: '',
    dailyData: {},
    transferData: [],
    approveInfo: {},
    point:{ lng: 114.044815, lat: 30.561407 },
    address:  {},
    addressList:[],
    radius:500,
    payDate: {},
    type: false, // 是否是转交选择人员
    kitValue: '', // 模板值
    fromApp: true,
    applyCompanyId: '',
    department: {},
  },
  mutations: {
    setInfoData (state, infoData) {
      state.infoData = infoData
    },
    setFormData(state, formData) {
      state.formData = formData
    },
    setInitialData(state, initialData) {
      state.initialData = {...state.initialData, ...initialData}
    },
    setSelectedList(state, selectedList) {
      const arr = [...selectedList]
      state.selectedList[`${state.status}`] = arr;
    },
    setSelectList(state, params) {
      if(!state.selectedList[`${state.status}`]) {
        state.selectedList[`${state.status}`] = [params]
      }else {
        state.selectedList[`${state.status}`] = params.isChecked ? [...state.selectedList[`${state.status}`], params] :
        state.selectedList[`${state.status}`].filter(item => item.id !== params.id)
      }
    },
    setCheckedList(state, params) {
      if(params.status) {
        state.selectedList[`${params.number}`] = state.selectedList[`${params.number}`]?.filter(item => item.staffId !== params.data.staffId)
      }else {
        state.selectedList[`${params.number}`] = state.selectedList[`${params.number}`] ?
        [...state.selectedList[`${params.number}`], params.data] : [params.data]
      }
    },
    clearSelectedList(state, selectedList) {
      state.selectedList = selectedList;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setDailyData(state, dailyData) {
      state.dailyData = dailyData;
    },
    setTransferData(state, transferData) {
      // state.transferData = transferData
      if(state.transferData.length === 0) {
        state.transferData = [transferData]
      }else {
        state.transferData = !transferData.check ? [...state.transferData, transferData] :
        state.transferData.filter(item => item.staffId !== transferData.staffId)
      }
    },
    setApproveInfo(state, approveInfo) {
      state.approveInfo = approveInfo
    },
    setPointData(state,point){
      state.point = point;
    },
    setAddressData(state,address){
      state.address = address;
    },
    setAddressListData(state,addressList){
      state.addressList = addressList;
    },
    setRadius(state,radius){
      state.radius=radius;
    },
    setPayDate(state,payDate) {
      state.payDate = payDate
    },
    setType(state, type) {
      state.type = type
    },
    setKitValue(state, kitValue) {
      state.kitValue = kitValue
    },
    setFromApp(state, fromApp) {
      state.fromApp = fromApp;
    },
    setApplyCompanyId(state, applyCompanyId) {
      state.applyCompanyId = applyCompanyId;
    },
    setDepartment(state, department) {
      state.department = department;
    },
  },
})
export default store